import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;

const SupportTicket = () => {

    const table1 = useRef(null);
    const table2 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        if (table2.current) {
            table12 = $(table2.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
        };
    }, []);


    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Support Tickets</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Support Tickets</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <ul className="nav nav-tabs nav-primary" role="tablist">
                        <li className="nav-item" role="presentation">
                            <Link className="nav-link active" data-bs-toggle="tab" to="#pending" role="tab" aria-selected="true">
                                <div className="d-flex align-items-center">
                                    <div className="tab-icon"><i className="bx bx-time font-18 me-1" /></div>
                                    <div className="tab-title">Pending</div>
                                </div>
                            </Link>
                        </li>
                        <li className="nav-item" role="presentation">
                            <Link className="nav-link" data-bs-toggle="tab" to="#resolved" role="tab" aria-selected="false">
                                <div className="d-flex align-items-center">
                                    <div className="tab-icon"><i className="bx bx-check-circle font-18 me-1" /></div>
                                    <div className="tab-title">Resolved</div>
                                </div>
                            </Link>
                        </li>
                    </ul>
                    <div className="tab-content mt-5">
                        <div className="tab-pane fade show active" id="pending" role="tabpanel">
                            <div className="entries-wrapper mb-3">
                                <label className="entries-label">
                                    <span>Showing</span>
                                    <select className="entries-select">
                                        <option value={10} selected>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                    <span>Entries</span>
                                </label>
                            </div>
                            <div className="card radius-10 w-100">
                                <div className="card-body">
                                    <div classname="table-responsive">
                                        <table className="table table-striped table-bordered align-middle" ref={table1}>
                                            <thead>
                                                <tr>
                                                    <th>Ticket ID</th>
                                                    <th>User Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Ticket Message</th>
                                                    <th>Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Example Pending Ticket */}
                                                <tr>
                                                    <td>201</td>
                                                    <td>@tomwilson</td> {/* @username */}
                                                    <td>tom@gmail.com</td>
                                                    <td>(524)-232-33</td> {/* Exact format you want */}
                                                    <td>Unable to login to my account</td>
                                                    <td>Jan 12, 2026</td> {/* US format date */}
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex gap-2">
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#view_modal">
                                                                    <i className="lni lni-eye" title="View" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#resolve_modal">
                                                                    <i className="bx bx-check-circle" title="Resolve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                    <i className="bx bx-trash" title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>202</td>
                                                    <td>@susanlee</td> {/* @username */}
                                                    <td>susan@gmail.com</td>
                                                    <td>(521)-232-33</td> {/* Exact format you want */}
                                                    <td>Payment issue while upgrading plan</td>
                                                    <td>Jan 18, 2026</td> {/* US format date */}
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex gap-2">
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#view_modal">
                                                                    <i className="lni lni-eye" title="View" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#resolve_modal">
                                                                    <i className="bx bx-check-circle" title="Resolve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                    <i className="bx bx-trash" title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="resolved" role="tabpanel">
                            <div className="entries-wrapper mb-3">
                                <label className="entries-label">
                                    <span>Showing</span>
                                    <select className="entries-select">
                                        <option value={10} selected>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                    <span>Entries</span>
                                </label>
                            </div>
                            <div className="card radius-10 w-100">
                                <div className="card-body">
                                    <div classname="table-responsive">
                                        <table className="table table-striped table-bordered align-middle" ref={table2}>
                                            <thead>
                                                <tr>
                                                    <th>Ticket ID</th>
                                                    <th>User Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Ticket Message</th>
                                                    <th>Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Example Pending Ticket */}
                                                <tr>
                                                    <td>201</td>
                                                    <td>@tomwilson</td> {/* @username */}
                                                    <td>tom@gmail.com</td>
                                                    <td>(524)-232-33</td> {/* Exact format you want */}
                                                    <td>Unable to login to my account</td>
                                                    <td>Jan 12, 2026</td> {/* US format date */}
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex gap-2">
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#view_modal">
                                                                    <i className="lni lni-eye" title="View" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#resolve_modal">
                                                                    <i className="bx bx-check-circle" title="Resolve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                    <i className="bx bx-trash" title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>202</td>
                                                    <td>@susanlee</td> {/* @username */}
                                                    <td>susan@gmail.com</td>
                                                    <td>(521)-232-33</td> {/* Exact format you want */}
                                                    <td>Payment issue while upgrading plan</td>
                                                    <td>Jan 18, 2026</td> {/* US format date */}
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex gap-2">
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#view_modal">
                                                                    <i className="lni lni-eye" title="View" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#resolve_modal">
                                                                    <i className="bx bx-check-circle" title="Resolve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                    <i className="bx bx-trash" title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="view_modal" tabIndex={-1} aria-labelledby="ticketModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h5 className="modal-title" id="ticketModalLabel">Ticket Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        {/* Modal Body */}
                        <div className="modal-body">
                            <div className="profile_modal_wrap">
                                <div className="main-body">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <form>
                                                {/* Ticket ID */}
                                                <div className="row mb-3 align-items-center">
                                                    <div className="col-sm-3">
                                                        <h6 className="mb-0">Ticket ID</h6>
                                                    </div>
                                                    <div className="col-sm-9 text-secondary">
                                                        <input type="text" className="form-control" readOnly defaultValue="#201" />
                                                    </div>
                                                </div>
                                                {/* User Name */}
                                                <div className="row mb-3 align-items-center">
                                                    <div className="col-sm-3">
                                                        <h6 className="mb-0">User Name</h6>
                                                    </div>
                                                    <div className="col-sm-9 text-secondary">
                                                        <input type="text" className="form-control" readOnly defaultValue="@ameliaclark" />
                                                    </div>
                                                </div>
                                                {/* Email */}
                                                <div className="row mb-3 align-items-center">
                                                    <div className="col-sm-3">
                                                        <h6 className="mb-0">Email</h6>
                                                    </div>
                                                    <div className="col-sm-9 text-secondary">
                                                        <input type="text" className="form-control" readOnly defaultValue="amelia@gmail.com" />
                                                    </div>
                                                </div>
                                                {/* Phone Number */}
                                                <div className="row mb-3 align-items-center">
                                                    <div className="col-sm-3">
                                                        <h6 className="mb-0">Phone Number</h6>
                                                    </div>
                                                    <div className="col-sm-9 text-secondary">
                                                        <input type="text" className="form-control" readOnly defaultValue="(524)-232-33" />
                                                    </div>
                                                </div>
                                                {/* Ticket Message */}
                                                <div className="row mb-3 align-items-center">
                                                    <div className="col-sm-3">
                                                        <h6 className="mb-0">Ticket Message</h6>
                                                    </div>
                                                    <div className="col-sm-9 text-secondary">
                                                        <textarea className="form-control" rows={3} readOnly defaultValue={"Hi, I’m facing an issue with my recent booking. Please check and assist."} />
                                                    </div>
                                                </div>
                                                {/* Submission Date */}
                                                <div className="row mb-3 align-items-center">
                                                    <div className="col-sm-3">
                                                        <h6 className="mb-0">Date</h6>
                                                    </div>
                                                    <div className="col-sm-9 text-secondary">
                                                        <input type="text" className="form-control" readOnly defaultValue="Jan 12, 2026" /> {/* US format */}
                                                    </div>
                                                </div>
                                                {/* Resolution Notes (optional for resolved tickets) */}
                                                <div className="row mb-3 align-items-center">
                                                    <div className="col-sm-3">
                                                        <h6 className="mb-0">Resolution Notes</h6>
                                                    </div>
                                                    <div className="col-sm-9 text-secondary">
                                                        <textarea className="form-control" rows={2} readOnly defaultValue={"Hi, Lorem ipsum dolor sit amet consectetur adipisicing elit."} />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Modal Footer */}
                        <div className="modal-footer">
                            <button type="button" className="btn btn-decline" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="resolve_modal" tabIndex={-1} aria-labelledby="approveModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0 radius-10">
                        <div className="modal-header">
                            <h5 className="modal-title" id="approveModalLabel">Notes</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="mb-3 mt-3">
                                <textarea className="form-control" id="resolveNotes" rows={3} placeholder="Enter resolution notes here..." defaultValue={""} />
                            </div>
                        </div>
                        <div className="modal-footer bg-light rounded-bottom-4">
                            <button type="button" className="btn btn-decline" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" id="approveTicketBtn" className="btn btn-approve">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="delete_modal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <h5>Are you sure you want to delete this ticket?</h5>
                        </div>
                        <div className="modal-footer modal-center">
                            <button type="button" className="btn btn-decline">No</button>
                            <button type="button" className="btn btn-approve" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SupportTicket